import { memo } from "react";
import PropTypes from "prop-types";
import { Layout, Avatar, Dropdown, Switch, Tooltip } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MenuOutlined,
  UserOutlined,
  DownOutlined,
  BulbOutlined,
  BulbFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import NotificationPopover from "components/NotificationPopover";
import { setOpenNotificationPopover } from "providers/NotificationProvider/slice";
import { toggleTheme } from "providers/GeneralProvider/slice";
import { useViewportSize } from "hooks";
import { VIEW_PORT_SIZE } from "utils/constants";
import "./styles.less";
import _ from "lodash";

const { Header } = Layout;

const Navbar = ({
  currentUser = {},
  menu,
  collapsed,
  toggleCollapse,
  toggleCollapseMenu,
  isDesktopViewport,
}) => {
  const dispatch = useDispatch();
  const size = useViewportSize();
  const isMobile = size.width <= VIEW_PORT_SIZE.TABLET;
  const themeMode = useSelector((state) => _.get(state, "general.themeMode", "light"));

  const handleOpenPopover = (value) => {
    dispatch(setOpenNotificationPopover({ isOpen: value }));
  };

  const handleToggleTheme = () => {
    dispatch(toggleTheme());
  };

  return (
    <Header className="app-header">
      <div className="header-left">
        {isDesktopViewport ? (
          <span className="collapse-trigger" onClick={toggleCollapse}>
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </span>
        ) : (
          <span className="collapse-trigger" onClick={() => toggleCollapseMenu(true)}>
            <MenuOutlined />
          </span>
        )}
      </div>
      <div className="header-right">
        <Tooltip title={themeMode === "dark" ? "Chế độ sáng" : "Chế độ tối"}>
          <span className="theme-toggle" onClick={handleToggleTheme}>
            {themeMode === "dark" ? <BulbFilled /> : <BulbOutlined />}
          </span>
        </Tooltip>
        <NotificationPopover handleOpenPopover={handleOpenPopover} />
        <Dropdown trigger={["click"]} overlay={menu} placement="bottomRight">
          <div className="user-dropdown-trigger">
            <Avatar
              shape="circle"
              size={32}
              icon={<UserOutlined />}
              src={
                _.isEmpty(currentUser.avatarUrl) ? "" : currentUser.avatarUrl
              }
            />
            <span className="user-name">
              {!_.isEmpty(currentUser.name)
                ? currentUser.name
                : currentUser.email}
            </span>
            <DownOutlined style={{ fontSize: 10 }} />
          </div>
        </Dropdown>
      </div>
    </Header>
  );
};

Navbar.propTypes = {
  toggleCollapseMenu: PropTypes.func,
  toggleCollapse: PropTypes.func,
  collapsed: PropTypes.bool,
  currentUser: PropTypes.object,
  menu: PropTypes.func,
  isDesktopViewport: PropTypes.bool,
};

export default memo(Navbar);
